import { OnboardingFlow } from '@/components/onboarding/OnboardingFlow';

const Index = () => {
  return <OnboardingFlow />;
};

export default Index;
